import { useState, useRef, useEffect } from "react";
import { Smile } from "lucide-react";

// Emoji data array
const emojiGroups = [
  {
    type: "Cảm xúc",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😌",
      "😍",
      "🥰",
      "😘",
      "😗",
      "😙",
      "😚",
      "😋",
      "😛",
      "😝",
      "😜",
      "🤪",
      "🤨",
      "🧐",
      "🤓",
      "😎",
      "🤩",
      "🥳",
      "😏",
      "😒",
      "😞",
      "😔",
      "😟",
      "😕",
      "🙁",
      "☹️",
      "😣",
      "😖",
      "😫",
      "😩",
      "🥺",
      "😢",
      "😭",
      "😤",
      "😠",
      "😡",
      "🤬",
      "🤯",
      "😳",
      "🥵",
      "🥶",
      "😱",
      "😨",
      "😰",
      "😥",
      "😓",
      "🤗",
      "🤔",
      "🤭",
      "🤫",
      "🤥",
      "😶",
      "😐",
      "😑",
      "😬",
      "🙄",
      "😯",
      "😦",
      "😧",
      "😮",
      "😲",
      "🥱",
      "😴",
      "🤤",
      "😪",
      "😵",
      "🤐",
      "🥴",
      "🤢",
      "🤮",
      "🤧",
      "😷",
      "🤒",
      "🤕",
    ],
  },
  {
    type: "Cử chỉ",
    emojis: [
      "👋",
      "🤚",
      "🖐",
      "✋",
      "🖖",
      "👌",
      "🤏",
      "✌️",
      "🤞",
      "🖖",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝️",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "🤝",
      "🙌",
      "👏",
      "👐",
      "🤲",
      "🤝",
    ],
  },
  {
    type: "Con người",
    emojis: [
      "👶",
      "🧒",
      "👦",
      "👧",
      "🧑",
      "👨",
      "👩",
      "🧓",
      "👴",
      "👵",
      "🦸",
      "🦹",
      "👨‍🚀",
      "👩‍🚀",
      "👨‍🎨",
      "👩‍🎨",
      "👨‍⚕️",
      "👩‍⚕️",
      "👨‍🏫",
      "👩‍🏫",
      "👨‍🍳",
      "👩‍🍳",
      "👨‍🔬",
      "👩‍🔬",
      "👨‍💻",
      "👩‍💻",
      "👨‍🔧",
      "👩‍🔧",
      "👨‍🏭",
      "👩‍🏭",
      "👮‍♂️",
      "👮‍♀️",
      "🕵️‍♂️",
      "🕵️‍♀️",
      "💂‍♂️",
      "💂‍♀️",
      "🕺",
      "💃",
      "🕴",
      "👯‍♂️",
      "👯‍♀️",
      "👫",
      "👬",
      "👭",
      "💏",
      "💑",
      "👨‍👩‍👦",
      "👨‍👩‍👧",
      "👨‍👩‍👧‍👦",
      "👨‍👩‍👦‍👦",
      "👨‍👩‍👧‍👧",
    ],
  },
  {
    type: "Tự nhiên",
    emojis: [
      "🐶",
      "🐱",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐯",
      "🦁",
      "🦄",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🦍",
      "🦧",
      "🦮",
      "🐕",
      "🐩",
      "🐈",
      "🐓",
      "🦜",
      "🦢",
      "🦩",
      "🦚",
      "🦆",
      "🦅",
      "🦉",
      "🦇",
      "🦋",
      "🐌",
      "🐛",
      "🦟",
      "🦗",
      "🦠",
      "🌸",
      "🌻",
      "🌹",
      "🌷",
      "🍀",
      "🍄",
      "🌞",
      "🌝",
      "🌚",
      "🌜",
      "🌛",
      "🌎",
      "🌍",
      "🌏",
    ],
  },
  {
    type: "Đồ ăn",
    emojis: [
      "🍏",
      "🍎",
      "🍐",
      "🍊",
      "🍋",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🍈",
      "🍒",
      "🍑",
      "🥭",
      "🍍",
      "🥥",
      "🥑",
      "🍆",
      "🥕",
      "🌽",
      "🌶",
      "🥒",
      "🥬",
      "🥦",
      "🥔",
      "🍞",
      "🥐",
      "🥖",
      "🥨",
      "🥯",
      "🥞",
      "🧇",
      "🍗",
      "🍖",
      "🥩",
      "🍔",
      "🍟",
      "🍕",
      "🌭",
      "🥪",
      "🌮",
      "🌯",
      "🥙",
      "🍜",
      "🍣",
      "🍱",
      "🍛",
      "🥗",
      "🍰",
      "🎂",
      "🍩",
      "🍪",
      "🍫",
      "🍿",
      "☕",
      "🥤",
      "🍺",
      "🍷",
    ],
  },
  {
    type: "Du lịch",
    emojis: [
      "🚗",
      "🚕",
      "🚙",
      "🚌",
      "🚎",
      "🏎",
      "🚓",
      "🚑",
      "🚒",
      "🚐",
      "🚜",
      "🛵",
      "🏍",
      "🚲",
      "🛴",
      "🛹",
      "🚇",
      "🚂",
      "✈️",
      "🚀",
      "🛸",
      "⛵",
      "🛳",
      "🚢",
    ],
  },
  {
    type: "Đồ vật",
    emojis: [
      "💡",
      "🔦",
      "🏮",
      "🕯",
      "🧯",
      "📱",
      "💻",
      "🖥",
      "🖨",
      "⌨️",
      "🖱",
      "🖲",
      "📞",
      "☎️",
      "📺",
      "📷",
      "🎥",
      "📸",
      "🎞",
      "🕰",
      "⏰",
      "⏳",
      "🔑",
      "🏆",
      "🏅",
      "🎖",
      "🥇",
      "🥈",
      "🥉",
      "🎭",
      "🎨",
      "🎤",
      "🎧",
      "🎼",
      "🎹",
      "🎷",
      "🎺",
      "🎸",
      "🥁",
    ],
  },
];

export function EmojiPicker({ handleEmojiSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={pickerRef}>
      <button
        className="p-1.5 rounded-md hover:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700"
        onClick={() => setIsOpen(!isOpen)}
        title="Biểu cảm"
        aria-label="Biểu cảm"
      >
        <Smile className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 bottom-full mb-2 bg-white rounded-lg shadow-lg border border-gray-200 p-2 w-72 max-h-72 overflow-y-auto z-10">
          {emojiGroups.map((emojiGroup, index) => (
            <div key={index} className="pb-2">
              <div className="font-medium text-sm mb-2 text-gray-700 border-b pb-1">
                {emojiGroup.type}
              </div>
              <div className="grid grid-cols-8 gap-1">
                {emojiGroup.emojis.map((emoji, index) => (
                  <button
                    key={index}
                    className="h-8 w-8 flex items-center justify-center hover:bg-gray-100 rounded-md transition-colors"
                    onClick={() => {
                      handleEmojiSelect(emoji);
                    }}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
